import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { apiEndPoints } from 'src/app/common/constants/api-endpointsconstant';
import { ApiService } from 'src/app/common/services/api.service';
import { ReportService } from 'src/app/reports/services/report.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class rentUnitSizeWisePropertyDetailService {
  constructor(
    private apiServive: ApiService,
    private reportService: ReportService,
    public translate: TranslateService
  ) {}
  placeCode: any = null;
  userInfo: any = null;
  CurrencyCode: any = null;
  officeRentPayload: any = {
    pageSize: 20,
    pageNumber: 0,
    sort_order: null,
    year: null
  }
  retailRentPayload: any = {
    pageSize: 20,
    pageNumber: 0,
    sort_order: null,
    year: null
  }
  getRentUnitSizeWise(payload: any, property_uid:string, tableType: string) {
      let queryParams = { ...this.reportService.queryParams };
      // delete queryParams['property_category']
    //   if (queryParams?.year) {
    //   queryParams.year = this.reportService.yearMaxValue(queryParams.year);
    // } else {
    //   if(queryParams?.transaction_date) {
    //     queryParams['year'] = this.reportService.getTTMmaxYear(queryParams?.transaction_date);
    //   } else {
    //     queryParams['year'] = new Date().getFullYear();
    //   }
    // }
      // const changeParams = this.reportService.setfilterQueryParams(queryParams);
      let offset = payload.pageNumber || 0
      // ${property_uid}
      // TSTLA00320
      let url: string = `${environment.miUrl}${tableType === 'officeRent' ? apiEndPoints.propertyDetailOfficeUnitSize : apiEndPoints.propertyDetailRetailUnitSize}?limit=${payload?.pageSize}&offset=${offset}&property_uid=${property_uid}&report_id=${queryParams.rid}`;
      if (payload.sort_order) {
        url += `&sort_order=${payload.sort_order}`;
      }
      if(offset == 0){
        url += "&is_count=true"
      }
      return this.apiServive.get(url, false);
    }
}
